module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    class: ['card-header', _vm.headerColor]
  }), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "small-text"
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _c('p', {
    staticClass: "big-text"
  }, [_vm._v(" " + _vm._s(_vm.deveExibirDados ? (_vm.quantidadeDeSolicitacoes + " solicitações") : '\u00A0') + " ")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.valor))]), _vm._v(" "), _c('p', {
    staticClass: "percentage"
  }, [_vm._v(_vm._s(_vm.porcentagem) + "% do valor total")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9543dfcc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9543dfcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/DashCard.vue
// module id = 1138
// module chunks = 1